import Helpers from "../../helpers/helpers";
import { server } from "../globalSettings";

export const requestAuthOption = (method, data) => {
    let token = JSON.parse(localStorage.getItem("token"));

    let headers = {
        Authorization: `Bearer ${token}`,
    };

    // If data is NOT FormData, set Content-Type to application/json
    if (!(data instanceof FormData)) {
        headers['Content-Type'] = 'application/json';
    }

    const requestOptions = {
        method: method,
        headers: headers,
        body: data instanceof FormData ? data : JSON.stringify(data)
    };

    return requestOptions;
};

export const salesPerformanceApi = async (payload) => {
    const request = requestAuthOption("GET");
    let doctor_ids = '';
    if (payload?.doctor_ids?.length > 0) {
        doctor_ids = payload?.doctor_ids?.map(id => `doctor_ids[]=${encodeURIComponent(id)}`).join('&') || '';
    }
    try {
        const response = await fetch(
            `${server}report/sales?date_filter=${payload.period}&start=${payload.start}&end=${payload.end}&${doctor_ids}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })
    }
};

export const doctorPerformanceApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(
            `${server}report/doctors`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data.data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })
    }
};

export const doctorReportDetailsApi = async (payload) => {

    const request = requestAuthOption("GET")
    try {
        const response = await fetch(
            `${server}report/${payload.id}?month=${payload.month}&year=${payload.year}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field" || data?.code === "validation_failed") {
                        reject(data.errors);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })
    }
};

export const doctorPaymentReportApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(
            `${server}report/${payload.id}/payments?paginate=${payload.page}&size=${payload.length}&sort=id&sort_order=desc`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field" || data?.code === "validation_failed") {
                        reject(data.errors);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })
    }
};

export const doctorPayCommissionApi = async (payload) => {
    const request = requestAuthOption("POST", payload)
    try {
        const response = await fetch(
            `${server}report/pay`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field" || data?.code === "validation_failed") {
                        reject(data.errors);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })
    }
};

export const exportDoctorSalesApi = async (payload) => {
    const request = requestAuthOption("POST")
    try {
        const response = await fetch(`${server}report/orders/export?doctor_id=${payload.doctor_id}&month=${payload.month}&year=${payload.year}`, request)
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data);
                        reject(data);
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    resolve({ data: data, api: payload?.api });
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })

    }
};

export const exportDoctorPerformanceApi = async (payload) => {
    const request = requestAuthOption("POST")
    let doctor_ids = '';
    if (payload?.doctor_ids?.length > 0) {
        doctor_ids = payload.doctor_ids.map(id => `doctor_ids[]=${encodeURIComponent(id)}`).join('&');
    }
    try {
        const response = await fetch(
            `${server}report/doctors/export`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })
    }
};
